import { Box, HStack, VStack } from "@chakra-ui/react";
import { Heading, Text } from "@equidefi/ui";
import { Icon } from "@equidefi/ui/icon";
import type React from "react";
import { Link } from "react-router";

export type Scheme = "yellow" | "green" | "red" | "darkGray" | "blue";

export type IconComponent = (typeof Icon)[string];

const DashedCircle: IconComponent = (props) => <Icon.Circle strokeDasharray="3 3" {...props} />;

export const SCHEME_ICON: Record<Scheme, IconComponent> = {
  yellow: Icon.AlertTriangle,
  green: Icon.CheckCircle,
  red: Icon.XCircle,
  darkGray: DashedCircle,
  blue: Icon.Circle,
};

export interface InvestmentStepCardProps {
  scheme: Scheme;
  label: string;
  heading: string;
  text: string;
  icon: IconComponent;
  to: string;
}

export const InvestmentStepCard: React.FC<InvestmentStepCardProps> = ({
  scheme,
  label,
  heading,
  text,
  icon: TitleIcon,
  to,
}) => {
  const EyebrowIcon = SCHEME_ICON[scheme];

  return (
    <Box
      as={Link}
      to={to}
      display="block"
      w="full"
      bg="white"
      overflow="hidden"
      borderRadius={{ base: "12px", md: "16px" }}
      border="1px solid"
      borderColor={`equidefi.${scheme}Border`}
      transition="box-shadow 0.15s"
      _hover={{ boxShadow: "md", textDecoration: "none" }}>
      <HStack
        bg={`equidefi.${scheme}Tint`}
        spacing="2"
        fontSize={{ base: "12px", md: "14px" }}
        px={{ base: "16px", md: "24px" }}
        py={{ base: "8px", md: "14px" }}>
        <EyebrowIcon size="1.5em" color="#171c2c" />
        <Text
          m="0"
          color="#171c2c"
          fontWeight="medium"
          fontSize={{ base: "11px", md: "13px" }}
          letterSpacing="0.02em"
          textTransform="uppercase">
          {label}
        </Text>
      </HStack>

      <VStack align="stretch" spacing={{ base: "6px", md: "12px" }} p={{ base: "16px", md: "24px" }}>
        <HStack spacing="2" fontSize={{ base: "17px", md: "22px" }}>
          <TitleIcon size="1.25em" color="#171c2c" />
          <Heading m="0" fontWeight="bold" color="#171c2c" fontSize="inherit">
            {heading}
          </Heading>
        </HStack>

        <Text m="0" color="#171c2c" fontSize={{ base: "14px", md: "16px" }}>
          {text}
        </Text>

        <HStack spacing="1" color="equidefi.blue" fontWeight="semibold" fontSize={{ base: "14px", md: "15px" }}>
          <Text m="0" textDecoration="underline">
            View Details
          </Text>
          <Icon.ArrowRight size="1em" />
        </HStack>
      </VStack>
    </Box>
  );
};

export default InvestmentStepCard;
